import { usePostHog } from "posthog-js/react";
import { useCallback } from "react";

export function useSearchEmptyTracking() {
  const posthog = usePostHog();
  return useCallback(
    (query: string) => {
      posthog?.capture("Toolkit picker search empty", { search_query: query });
    },
    [posthog]
  );
}
